import React, { useEffect, useState, useRef } from "react";
import imgplaceholder from "../../assets/img/image-placeholder.png";
import imgloaderImage from "../../assets/img/generating.png";
import { generateVariations } from "../../actions/UserActions";
import { connect } from "react-redux";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { GetparticularVersion } from "../../actions/UserActions";

function AiImagegenration({ generateVariations, GetparticularVersion }) {
  const [imgloader, setImgloader] = useState(false);
  const [generatedImg, setGeneratedImg] = useState([]);
  const [imgNumbers, setImgNumbers] = useState(1);
  const [validation, setValidation] = useState(false);
  const [validationsize, setValidationsize] = useState(false);
  const [size, setSize] = useState("256x256");
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [disable, setDisable] = useState(true);
  const [validationImagetype, setValidationImagetype] = useState(false);
  const [theInputKey, setTheInputKey] = useState("");
  const [apierror, setApierror] = useState(false);
  const [aiVersion, setAiVersion] = useState("");
  const [numberofimageallowed, setNumberofimageallowed] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ]);
  const [resolutions, setResolutions] = useState([
    "256x256",
    "512x512",
    "1024x1024",
  ]);

  const fileInputRef = useRef(null);

  useEffect(() => {
    GetAiVersion();
  }, []);

  const GetAiVersion = () => {
    GetparticularVersion("Ai_image_variation").then((res) => {
      if (res.status === 200) {
        setAiVersion(res.data);
        if (res.data == "dall-e-3") {
          setNumberofimageallowed([1]);
          setResolutions(["1024x1024", "1024x1792", " 1792x1024"]);
          setSize("1024x1024");
        }
      }
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      // Validate the file type (only images allowed)
      if (
        file.type.startsWith("image/png") ||
        file.type.startsWith("image/jpg") ||
        file.type.startsWith("image/jpeg")
      ) {
        setSelectedFile(file);
        setDisable(false);
        setValidationImagetype(false);
        setApierror(false);
      } else {
        // alert("Please select a valid image file.");
        setValidationImagetype(true);
      }
    }
  };

  const handleClear = (value) => {
    let randomString = Math.random().toString(36);
    setSelectedFile(null);
    setImgloader(false);
    setGeneratedImg([]);
    setTheInputKey(randomString);
    setApierror(false);
    setValidationImagetype(false);
  };

  const handleClick = () => {
    setImgloader(true);
    let formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("imgNumbers", imgNumbers);
    formData.append("size", size);
    generateVariations(formData).then((res) => {
      if (res.status === 200) {
        setGeneratedImg(res.data.images);
        setImgloader(false);
      } else {
        setImgloader(false);
        setApierror(true);
      }
    });
  };

  const onChangeseletfeild = (e) => {
    setImgNumbers(e);
    if (e != "0") {
      setValidation(false);
    } else {
      setValidation(true);
    }
  };

  const onChangesize = (e) => {
    setSize(e);
    if (e != "0") {
      setValidationsize(false);
    } else {
      setValidationsize(true);
    }
  };
  const handleFileInputClick = () => {
    // Trigger the file input's click event
    fileInputRef.current.click();
  };
  // console.log("selectedFile", selectedFile);
  return (
    // <div class="image-generator-container">
    //   <h1>
    //     <span class="dalle">Dotwork</span> Image Variator
    //   </h1>

    //   <div class="col-md-6 col-lg-6 col-xl-6">
    //     <ul class="list-unstyled">
    //       <li class="bg-white mb-3">
    //         <div class="form-outline">
    //           <div className="c-select status-select mt-2 mb-2">
    //             <select
    //               className="form-control form-control-sm form-control-head"
    //               style={{ width: "50%" }}
    //               onChange={(e) => {
    //                 onChangeseletfeild(e.target.value);
    //               }}
    //               value={imgNumbers}
    //             >
    //               <option value="0">Select number of images</option>
    //               <option value="1">1</option>
    //               <option value="2">2</option>
    //               <option value="3">3</option>
    //               <option value="4">4</option>
    //               <option value="5">5</option>
    //               <option value="6">6</option>
    //               <option value="7">7</option>
    //               <option value="8">8</option>
    //               <option value="9">9</option>
    //               <option value="10">10</option>
    //             </select>
    //           </div>
    //           {validation ? (
    //             <p style={{ color: "red" }}>please select number of images</p>
    //           ) : (
    //             ""
    //           )}
    //         </div>
    //       </li>
    //     </ul>
    //   </div>

    //   <div class="col-md-6 col-lg-6 col-xl-6">
    //     <ul class="list-unstyled">
    //       <li class="bg-white mb-3">
    //         <div class="form-outline">
    //           <div className="c-select status-select mt-2 mb-2">
    //             <select
    //               className="form-control form-control-sm form-control-head"
    //               style={{ width: "50%" }}
    //               onChange={(e) => {
    //                 onChangesize(e.target.value);
    //               }}
    //               value={size}
    //             >
    //               <option value="0">Select size of image</option>
    //               <option value="256x256">256x256</option>
    //               <option value="512x512">512x512</option>
    //               <option value="1024x1024">1024x1024</option>
    //             </select>
    //           </div>
    //           {validationsize ? (
    //             <p style={{ color: "red" }}>please select size of image</p>
    //           ) : (
    //             ""
    //           )}
    //         </div>
    //       </li>
    //     </ul>
    //   </div>

    //   <div class="content">
    //     <input
    //       type="file"
    //       id="myfile"
    //       onChange={handleFileChange}
    //       name="myfile"
    //     />

    //     {validationImagetype ? (
    //       <p style={{ color: "red" }}>Please select a valid image file.</p>
    //     ) : (
    //       ""
    //     )}

    //     <button
    //       class="generate-btn"
    //       onClick={handleClick}
    //       disabled={disable && !validation && !validationsize ? true : false}
    //     >
    //       Generate Image varations
    //     </button>

    //     <button
    //       class="generate-btn"
    //       onClick={handleClear}
    //       disabled={disable ? true : false}
    //     >
    //       Clear
    //     </button>

    //     <div class="image-container">
    //       {imgloader ? (
    //         <img src={imgloaderImage} alt="laderImage" />
    //       ) : generatedImg.length > 0 ? (
    //         generatedImg.map((singleimg) => {
    //           return (
    //             <>
    //               <img src={singleimg.url} alt="no record" />

    //               <a
    //                 href={singleimg.url}
    //                 download="image.jpg"
    //                 target="_blank"
    //                 rel="noopener noreferrer"
    //               >
    //                 Download Image
    //               </a>
    //               {/* <button
    //                 onClick={() => {
    //                   handleDownload(singleimg.b64_json);
    //                 }}
    //               >
    //                 Download Image
    //               </button> */}
    //             </>
    //           );
    //         })
    //       ) : (
    //         <img src={imgplaceholder} alt="no record" />
    //       )}
    //     </div>
    //   </div>
    // </div>

    <div class="image-generator-container step-progress transaction-create">
      <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
        <Col xs={12} sm={3}>
          <h4 className="title-med mt-0 pt-1">AI Image Variations</h4>
        </Col>
      </Row>
      <div className="multi-step multi-step-admin">
        <div className="admin-steps admin-content-area">
          <div className="container-custom">
            <Form className="form-sm form-admin">
              <Row>
                <Col md={12}>
                  <Row>
                    <Col xs={12} sm={6}>
                      <Form.Group>
                        <Form.Label>Select an Image</Form.Label>
                        <div>
                          <input
                            type="file"
                            id="myfile"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            name="myfile"
                            key={theInputKey || ""}
                          />
                          <Button
                            onClick={handleFileInputClick}
                            variant="primary"
                            className="btn-blue w-90 font-14 mr-3 generate-btn"
                          >
                            Upload Image
                          </Button>

                          <h6>{selectedFile && selectedFile.name}</h6>
                        </div>
                        {validationImagetype ? (
                          <p style={{ color: "red" }}>
                            Please select a valid image file.
                          </p>
                        ) : (
                          ""
                        )}
                        {apierror ? (
                          <p style={{ color: "red" }}>
                            AI cannot make variant of this image
                          </p>
                        ) : (
                          ""
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Number of Images</Form.Label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            onChangeseletfeild(e.target.value);
                          }}
                          value={imgNumbers}
                        >
                          <option value="0">Select number of images</option>
                          {numberofimageallowed &&
                            numberofimageallowed.map((item) => {
                              return <option value={item}>{item}</option>;
                            })}
                        </select>
                        {validation ? (
                          <p style={{ color: "red" }}>
                            Please select number of images
                          </p>
                        ) : (
                          ""
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Size of Image</Form.Label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            onChangesize(e.target.value);
                          }}
                          value={size}
                        >
                          <option value="0">Select size of image</option>
                          {resolutions &&
                            resolutions.map((item) => {
                              return <option value={item}>{item}</option>;
                            })}
                        </select>
                        {validationsize ? (
                          <p style={{ color: "red" }}>
                            Please select size of image
                          </p>
                        ) : (
                          ""
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="form-group pt-4 pb-4">
                <Col>
                  <Button
                    variant="primary"
                    className="btn-blue w-90 font-14 mr-3 generate-btn"
                    onClick={handleClick}
                    disabled={
                      disable || validation || validationsize ? true : false
                    }
                  >
                    Generate Image varations
                  </Button>

                  <Button
                    variant="primary"
                    className="btn-blue btn-outlined w-90 font-14 generate-btn"
                    onClick={handleClear}
                    disabled={
                      disable || validation || validationsize ? true : false
                    }
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
            <div>
              <Row>
                {imgloader ? (
                  <>
                    <Col xs="12" sm="3">
                      <Card className="transaction-single">
                        <img src={imgloaderImage} alt="no record" />
                      </Card>
                    </Col>
                  </>
                ) : generatedImg.length > 0 ? (
                  generatedImg.map((singleimg) => {
                    return (
                      <>
                        <Col xs="12" sm="3">
                          <Card className="transaction-single">
                            <img src={singleimg.url} alt="images" />
                          </Card>
                        </Col>
                      </>
                    );
                  })
                ) : (
                  <Col xs="12" sm="3">
                    <Card className="transaction-single">
                      <img src={imgplaceholder} alt="no record" />
                    </Card>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="col-md-6 col-lg-6 col-xl-6">
      <ul class="list-unstyled">
        <li class="bg-white mb-3">
          <div class="form-outline">
            <div className="c-select status-select mt-2 mb-2">
              <select
                className="form-control form-control-sm form-control-head"
                style={{ width: "50%" }}
                onChange={(e) => {
                  onChangeseletfeild(e.target.value);
                }}
                value={imgNumbers}
              >
                <option value="0">Select number of images</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
            </div>
            {validation ? (
              <p style={{ color: "red" }}>please select number of images</p>
            ) : (
              ""
            )}
          </div>
        </li>
      </ul>
    </div>

    <div class="col-md-6 col-lg-6 col-xl-6">
      <ul class="list-unstyled">
        <li class="bg-white mb-3">
          <div class="form-outline">
            <div className="c-select status-select mt-2 mb-2">
              <select
                className="form-control form-control-sm form-control-head"
                style={{ width: "50%" }}
                onChange={(e) => {
                  onChangesize(e.target.value);
                }}
                value={size}
              >
                <option value="0">Select size of image</option>
                <option value="256x256">256x256</option>
                <option value="512x512">512x512</option>
                <option value="1024x1024">1024x1024</option>
              </select>
            </div>
            {validationsize ? (
              <p style={{ color: "red" }}>please select size of image</p>
            ) : (
              ""
            )}
          </div>
        </li>
      </ul>
    </div> */}

      {/* <div class="content">
      <textarea
        class="form-control"
        id="textAreaExample2"
        rows="4"
        value={prompt}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />

      <button
        class="generate-btn"
        onClick={handleClick}
        disabled={
          prompt.trim().length === 0 && !validation && !validationsize
            ? true
            : false
        }
      >
        Generate Image
      </button>

      <button
        class="generate-btn"
        onClick={handleClear}
        disabled={prompt.trim().length === 0 ? true : false}
      >
        Clear
      </button>

      <div class="image-container">
        {imgloader ? (
          <img src={imgloaderImage} alt="laderImage" />
        ) : generatedImg.length > 0 ? (
          generatedImg.map((singleimg) => {
            return <img src={singleimg.url} alt="no record" />;
          })
        ) : (
          <img src={imgplaceholder} alt="no record" />
        )}
      </div>
    </div> */}

      {/* <a
      href="images/image-placeholder.png"
      download="ai-image.png"
      class="download-btn"
    >
      <span class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
          />
        </svg>{" "}
      </span>
      Download
    </a> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    generateVariations,
    GetparticularVersion,
  }
)(AiImagegenration);
